import '../../common_screen/contest_tab/index_web.css';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { showErrorToast, showToast } from '../../../actions/app-actions-types';
import useGame from '../../../utilities/hooks/game';
import I18n from '../../../utilities/locale';
import {
  getRealBalanceObj,
  getRouteObjByGame,
  isMatchInScheduled,
  isSmartPhone
} from '../../../utilities/helper';
import { useLink } from 'react-router-stack';
import { setMyContestList } from '../../../actions/fantasy-yes-no-action-types';
import ContestListTabWeb from './index_web';
import ContestListTabMWeb from './index_mWeb';

const ContestListTab = () => {
  const navigate = useLink();

  const {
    gameType,
    item: matchItem,
    fantasyMatchClick,
    contestCategories,
    setAllContestList,
    balanceInfo = {}
  } = useGame();
  const balance = getRealBalanceObj(balanceInfo);
  const [contestCategoryList, setContestCategoryList] = useState([] as any[]);
  const [addCashVisible, setAddCashVisible] = useState(false);
  const [contestFilterVisible, setContestFilterVisible] = useState(false);
  const [contestShare, setContestShare] = useState(false);
  const [contestLink] = useState('');
  const [contestTitle] = useState('');
  const [contestConfirmModal, setContestConfirmModal] = useState(false);
  const [contestData, setContestData] = useState({} as any);
  const { entryFee = 0, bonusPercentage = 0 } = contestData;
  const { contestCategories: fantasyYesNoContestListByCategory } = useSelector(
    (state: any) => state.fantasy_yes_no
  );
  const { _id: matchId, status: matchStatus = '', gameState = 0, matchDelayed = false } = matchItem;
  const { myAnswersList } = useSelector((state: any) => state.fantasy_yes_no);
  const totalTeamsCount: any = myAnswersList[matchItem._id];
  const dispatch = useDispatch();

  useEffect(() => {
    getAllContestListAPI();
  }, [fantasyYesNoContestListByCategory]);

  const getAllContestListAPI = async () => {
    let result = fantasyYesNoContestListByCategory[matchItem._id];
    let resultList: any[] = [];
    result.forEach(function (item: any) {
      const { contests = [], _id = '' } = item;
      contests.sort(function (x: any, y: any) {
        return y.winningsAmount - x.winningsAmount;
      });
      const list = contests;
      const contestCategory = contestCategories[_id];
      resultList.push({
        header: {
          ...contestCategory,
          contestCount: contests.length
        },
        data: list
      });
    });
    resultList.sort(function (x, y) {
      const xPriority = x?.header?.priority || 0;
      const yPriority = y?.header?.priority || 0;
      return xPriority - yPriority;
    });
    setContestCategoryList(resultList);

    let contestCategoryData: any = [];
    resultList.forEach((elem: any) => {
      contestCategoryData.push({ ...elem.header, header: true });
      contestCategoryData = [...contestCategoryData, ...elem.data];
    });
  };

  const onRefresh = async () => {
    await getAllContestListAPI();
  };

  const showAllContest = (categoryId: any, title: any) => {
    dispatch(
      fantasyMatchClick({
        data: {
          ...matchItem,
          categoryId,
          title
        }
      })
    );
    let allContestList = fantasyYesNoContestListByCategory[matchItem['_id']].find(
      (item: any) => item._id === categoryId
    );
    dispatch(setAllContestList(allContestList['contests']));

    navigate.push(getRouteObjByGame(gameType)['all_contest']);
  };

  const onPressShare = async () => {};

  const onPressCard = (contest: any) => {
    dispatch(
      fantasyMatchClick({
        data: {
          ...matchItem,
          contest
        }
      })
    );
    navigate.push(getRouteObjByGame(gameType)['contest_details']);
  };

  const onApplyFilter = () => {
    dispatch(
      fantasyMatchClick({
        data: {
          ...matchItem,
          categoryId: '',
          title: 'All Contest',
          isAppliedFilter: true
        }
      })
    );
    setContestFilterVisible(false);
    navigate.push(getRouteObjByGame(gameType)['all_contest']);
  };

  const onPressEntryFee = () => {
    dispatch(
      fantasyMatchClick({
        data: {
          ...matchItem,
          categoryId: '',
          title: 'All Contest',
          defaultSort: 'Entry'
        }
      })
    );
    setAllContestData();
    navigate.push(getRouteObjByGame(gameType)['all_contest']);
  };

  const onPressPrizePool = () => {
    dispatch(
      fantasyMatchClick({
        data: {
          ...matchItem,
          categoryId: '',
          title: 'All Contest',
          defaultSort: 'PrizePool'
        }
      })
    );
    setAllContestData();
    navigate.push(getRouteObjByGame(gameType)['all_contest']);
  };

  const onPressSpots = () => {
    dispatch(
      fantasyMatchClick({
        data: {
          ...matchItem,
          categoryId: '',
          title: 'All Contest',
          defaultSort: 'Spots'
        }
      })
    );
    setAllContestData();
    navigate.push(getRouteObjByGame(gameType)['all_contest']);
  };

  const onPressWinners = () => {
    dispatch(
      fantasyMatchClick({
        data: {
          ...matchItem,
          categoryId: '',
          title: 'All Contest',
          defaultSort: 'Winner'
        }
      })
    );
    setAllContestData();
    navigate.push(getRouteObjByGame(gameType)['all_contest']);
  };

  const onClearFilter = () => {
    setAllContestData();
    setContestFilterVisible(false);
  };

  const onPressFilter = () => {
    setContestFilterVisible(true);
  };

  const onPressFilterDismiss = () => {
    setContestFilterVisible(false);
  };

  const onPressShareModalDismiss = () => {
    setContestShare(false);
  };

  const onPressDismissCashModal = () => {
    setAddCashVisible(false);
  };

  const onPressJoinContest = () => {
    setContestConfirmModal(false);
    dispatch(showToast('Contest Joined Successfully'));
    dispatch(setMyContestList({ contest: matchItem.contest, matchId: matchId }));
  };

  const isScheduled = isMatchInScheduled({
    matchStatus,
    gameState,
    matchDelayed,
    gameType
  });
  const onPressJoin = (contest: any) => {
    if (isScheduled) {
      setContestConfirmModal(true);
      setContestData(contest);
    } else {
      dispatch(showErrorToast(I18n.t('matchDeadlineFinishedSorryYouCannotJoinNow')));
    }
  };

  const onPressDismissContestConfirm = () => {
    setContestConfirmModal(false);
  };

  const setAllContestData = () => {
    let contest: any = [];

    fantasyYesNoContestListByCategory[matchItem['_id']].forEach((item: any) => {
      for (let contestItem of item.contests) {
        contest.push(contestItem);
      }
    });

    dispatch(setAllContestList([...contest]));
  };

  return (
    <React.Fragment>
      {isSmartPhone ? (
        <ContestListTabMWeb
          onPressFilter={onPressFilter}
          onPressEntryFee={onPressEntryFee}
          onPressPrizePool={onPressPrizePool}
          onPressSpots={onPressSpots}
          onPressWinner={onPressWinners}
          onPressCard={onPressCard}
          onPressShare={onPressShare}
          contestCategoryList={contestCategoryList}
          matchStatus={matchStatus}
          gameState={gameState}
          matchItem={matchItem}
          matchDelayed={matchDelayed}
          gameType={gameType}
          onApplyFilter={onApplyFilter}
          onClearFilter={onClearFilter}
          contestFilterVisible={contestFilterVisible}
          onPressFilterDismiss={onPressFilterDismiss}
          contestLink={contestLink}
          contestTitle={contestTitle}
          contestShare={contestShare}
          onPressShareModalDismiss={onPressShareModalDismiss}
          showAllContest={showAllContest}
          totalTeamsCount={totalTeamsCount}
          onPressJoinContest={onPressJoinContest}
          onRefresh={onRefresh}
          onPressJoin={onPressJoin}
          onPressWinners={onPressWinners}
          contestConfirmModal={contestConfirmModal}
          onPressDismissContestConfirm={onPressDismissContestConfirm}
          entryFee={entryFee}
          bonusPercentage={bonusPercentage}
          balance={balance}
          addCashVisible={addCashVisible}
          onPressDismissCashModal={onPressDismissCashModal}
        />
      ) : (
        <ContestListTabWeb
          onPressFilter={onPressFilter}
          onPressEntryFee={onPressEntryFee}
          onPressPrizePool={onPressPrizePool}
          onPressSpots={onPressSpots}
          onPressWinner={onPressWinners}
          onPressCard={onPressCard}
          onPressShare={onPressShare}
          contestCategoryList={contestCategoryList}
          matchStatus={matchStatus}
          gameState={gameState}
          totalTeamsCount={totalTeamsCount}
          matchItem={matchItem}
          matchDelayed={matchDelayed}
          gameType={gameType}
          onApplyFilter={onApplyFilter}
          onClearFilter={onClearFilter}
          contestFilterVisible={contestFilterVisible}
          onPressFilterDismiss={onPressFilterDismiss}
          contestLink={contestLink}
          contestTitle={contestTitle}
          contestShare={contestShare}
          onPressShareModalDismiss={onPressShareModalDismiss}
          showAllContest={showAllContest}
          onPressJoinContest={onPressJoinContest}
          onPressJoin={onPressJoin}
          onPressWinners={onPressWinners}
          contestConfirmModal={contestConfirmModal}
          onPressDismissContestConfirm={onPressDismissContestConfirm}
          entryFee={entryFee}
          bonusPercentage={bonusPercentage}
          balance={balance}
          addCashVisible={addCashVisible}
          onPressDismissCashModal={onPressDismissCashModal}
        />
      )}
    </React.Fragment>
  );
};

export default ContestListTab;
